import { serializable, alias, primitive } from 'serializr';

export default class ChaptorModel {
    @serializable(alias('id', primitive()))
    id?: number;

    @serializable(alias('is_active', primitive()))
    isActive?: string;

    @serializable(alias('name', primitive()))
    name?: string;

    @serializable(alias('position', primitive()))
    position?: string;
}
